const keys = {
  choices: {
    aluminium: 'Aluminium',
    annually: 'Annually',
    audibleAlarm: 'Audible alarm',
    basementOrSemibasement: 'Basement',
    cat: 'Cat',
    condo: 'Condo',
    copper: 'Copper',
    legalConsent: 'I agree',
    detached: 'Detached',
    dog: 'Dog',
    driverType: {
      mainDriver: 'Main',
      none: 'Not driving',
      occasionalDriver: 'Occasional',
    },
    electric: 'Electric',
    employed: 'Have a job',
    endRowBuilding: 'End-row building',
    female: 'Female',
    fireResistive: 'Fire resistant',
    fiveAndHalf: '5 and 1/2',
    forty: '$35,000 - $40,000',
    fortyfive: 'More than $40,000',
    fourAndHalf: '4 and 1/2',
    fullyFinished: "Yes and it's 100% finished",
    garage: {
      hasLivingSpace: {
        false: 'No',
        true: 'Yes',
      },
      numberOfCars: {
        1: '1',
        2: '2',
        3: '3',
        4: '4 or more',
      },
      type: {
        attached: 'Attached',
        basement: 'Basement',
        builtIn: 'Built in',
        detached: 'Detached',
        none: 'None',
      },
    },
    gas: 'Gas',
    gasFireplace: 'Gas fireplace',
    groundFloor: 'Ground floor',
    groundFloorAndBasement: 'Ground floor and basement',
    halfFinished: "Yes and it's 50% finished",
    hotWater: ' Hot water / Steam',
    house: 'House',
    inRowBuilding: 'In-row building',
    insideAndAboveGround: 'Inside and above ground',
    insideAndInGround: 'Inside and in-ground',
    insuredFor1year: '1 year or less',
    insuredFor2years: '2 years',
    insuredFor3years: '3 years',
    insuredFor4years: '4 years',
    insuredFor5yearsAndMore: '5+ years',
    linkedBurglarAlarm: 'Professionally monitored theft alarm installed',
    linkedFireAlarm: 'Professionally monitored fire alarm installed',
    male: 'Male',
    many: 'Yes, more than one',
    married: 'Married',
    masonry: 'Masonry',
    monthly: 'Monthly',
    zero: 'None',
    two: 'Two',
    threeOrMore: 'Three or more',
    no: 'No',
    noBasement: 'No',
    none: 'None',
    noneRegisterCarOwner: 'None, I am the only registered owner',
    notFinished: "Yes and it's not finished",
    notInsured: "I don't have insurance",
    notResponsible: 'Not responsible',
    oil: 'Oil',
    oilFireplace: 'Oil fireplace',
    oilHeating: 'Oil heating',
    one: 'One',
    onlyOne: 'Only one',
    other: 'Other',
    outsideAndAboveGround: 'Outside and above ground',
    outsideAndInGround: 'Outside and in-ground',
    owner: 'Own',
    plex: 'Plex',
    pool: {
      type: {
        aboveGround: 'Pool above ground',
        inGround: 'Pool inground',
        none: '$t(choices.none)',
      },
    },
    spaAboveGround: 'Spa above ground',
    spaInGround: 'Spa inground',
    responsible: 'Responsible',
    retired: 'Retired',
    secondAndUp: 'Above the ground floor',
    semiDetached: 'Semi-Detached',
    sherlockAntiTheft: 'Sherlock anti theft',
    sixAndMore: '6 and 1/2 or more',
    smokeDetector: 'Smoke Detector installed',
    smokeFreeHousehold: 'Smoke-free household',
    stone: 'Stone',
    stuco: 'Stucco / Aggregate',
    student: 'Student',
    studio: 'Studio or 1 and 1/2',
    tagTracking: 'Tag tracking',
    tenant: 'Rent',
    thirty: '$25,000 - $30,000',
    thirtyfive: '$30,000 - $35,000',
    threeAndHalf: '3 and 1/2',
    twenty: 'Less than $20,000',
    twentyfive: '$20,000 - $25,000',
    twoAndHalf: '2 and 1/2',
    twoAndMore: '2 or more',
    unemployed: 'Unemployed',
    universityDegree: 'University degree completed',
    vinyl: 'Vinyl',
    wood: 'Wood',
    woodBurningStove: 'Wood burning stove',
    woodFireplace: 'Wood fireplace',
    workFullTime: 'Work full-time or self-employed',
    workPartTime: 'Work part-time',
    yes: 'Yes',
    sawdust: 'Sawdust',
    uffi: 'Urea-formaldehyde foam insulation (UFFI)',
    mineralWool: 'Mineral wool',
    fiberglass: 'Fiberglass',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
